export const SETTINGS = {
  INTERNAL_API_URL:
    window.location.hostname === "localhost"
      ? "http://localhost:8080/api/v1/"
      : "/api/v1/",
  CAPTCHA_API_URL: "https://captcha.e-soobrakaj.mk/2b296d444c/",
};
